import moment from "moment";

export const formatYTData = (data) => {
    const chart_name = data?.chart_name;
    const resp_data = data?.response;
    if (chart_name === "YTRecentPosts") {
        let recentPosts = [];
        let data;
        data = resp_data.filter((item) => {
            // console.log("validte", item?._source);
            return item?._source?.post?.post_subtype !== "ads";
        });
        let tz = JSON.parse(localStorage.company).user_timezone_name;
        data?.forEach((item) => {
            let image_url = "https://2020assets.s3.amazonaws.com/images/" + item?._source?.post?.media[0].folder + "/" + item?._source?.post?.media[0].name;
            let profile_pic =
                "https://2020assets.s3.amazonaws.com/images/" + item?._source?.post_author?.media[0].folder + "/" + item?._source?.post_author?.media[0].name;
            let totalEngagement =
                item?._source.post?.engagement_values?.like_count +
                item?._source.post?.engagement_values?.comment_count +
                item?._source.post?.engagement_values?.share_count;

            // + item?._source.post?.engagement_values?.share_count +
            // item?._source.post?.engagement_values?.view_count;
            if (item) {
                recentPosts.push({
                    gender: item?._source?.post_author?.gender,
                    profile_pic: profile_pic,
                    username: item?._source?.handlers[0].value,
                    post_type: item?._source?.post?.media[0].type,
                    image_url: image_url,
                    content: item?._source?.post?.content,
                    title: item?._source?.post?.title,
                    post_url: item?._source?.post?.url,
                    created_date: moment(item?._source?.post?.published_date).tz(tz).format("DD MMM YYYY"),
                    hover_date: moment(item?._source?.post?.published_date).tz(tz).format("LLLL z"),
                    engagement: item?._source?.post?.engagement_values,
                    impact: item?._source.impact_value,
                    totalEngagement: totalEngagement,
                });
            }
        });

        recentPosts = recentPosts.slice(0, 10);
        return recentPosts;
    }
    if (chart_name === "total-subscribers") {
        let data = {
            followers_count: +resp_data || 0,
        };
        return data;
    }

    if (
        // TotalFollowers
        chart_name === "total-engagement" ||
        chart_name === "total-posts" ||
        chart_name === "total-posts-likes" ||
        chart_name === "total-posts-comments" ||
        chart_name === "total-posts-shares" ||
        chart_name === "total-posts-views" ||
        chart_name === "avg-view-duration" ||
        chart_name === "subscribers-gained" ||
        chart_name === "subscribers-lost"
    ) {
        let { data: presentDurationData } = resp_data.find((r) => r.name === "presentDurationData");
        let { data: previousDurationData } = resp_data.find((r) => r.name === "previousDurationData");

        let obj = {
            presentDurationData: null,
            previousDurationData: null,
            nodata: false,
            percentage_change: null,
            durationGap: +data?.durationGap?.toFixed(0) + 1,
        };
        const aggsArr = ["comment-count-stats", "like-count-stats", "share-count-stats", "view-count-stats"];
        switch (chart_name) {
            case "total-followers":
                obj.nodata = presentDurationData?.data?.follower_growth_overtime[0]?.total == 0;

                // obj.presentDurationData = presentDurationData.data?.follower_growth_overtime?.reduce((acc, curr) => {
                //     return acc + curr?.total;
                // }, 0);
                obj.presentDurationData = presentDurationData?.data?.follower_growth_overtime.at(-1)?.total;
                obj.previousDurationData = previousDurationData?.data?.follower_growth_overtime.at(-1)?.total;
                // obj.previousDurationData = previousDurationData.data?.follower_growth_overtime?.reduce((acc, curr) => {
                //     return acc + curr?.total;
                // }, 0);

                break;

            case "total-posts":
                // console.log("presentDurationData", presentDurationData);
                obj.nodata = presentDurationData?.hits?.total == 0;
                obj.presentDurationData = presentDurationData?.hits?.total;
                obj.previousDurationData = previousDurationData?.hits?.total;
                // console.log("ddadaa", obj.presentDurationData, obj.durationGap);
                obj.avg_val = +(obj.presentDurationData / obj.durationGap).toFixed(1); // avg value based on duration gap
                break;

            case "total-posts-likes":
            case "total-posts-comments":
            case "total-posts-shares":
            case "total-posts-views":
            case "avg-view-duration":
            case "subscribers-gained":
            case "subscribers-lost":
            case "total-engagement":
                obj.presentDurationData = presentDurationData?.data?.aggregations?.total_stats?.value;
                obj.previousDurationData = previousDurationData?.data?.aggregations?.total_stats?.value;
                // obj.avg_val = +(obj.presentDurationData / presentDurationData?.data?.hits?.total).toFixed(1);
                break;

            default:
                break;
        }
        if (chart_name === "avg-view-duration") {
            obj.presentDurationData = Math.round(obj.presentDurationData / 60);
            obj.previousDurationData = Math.round(obj.previousDurationData / 60);
        }
        if ((obj.presentDurationData && !(obj.presentDurationData > 0)) || obj.presentDurationData === 0) obj.nodata = true;

        if (!obj.nodata) {
            if (obj.previousDurationData !== 0)
                obj.percentage_change = +(((obj.presentDurationData - obj.previousDurationData) / obj.previousDurationData) * 100).toFixed(2);
        }

        return obj;
    }

    if (chart_name === "youtube_posts_overtime") {
        let data = { nodata: resp_data.hits.total === 0, lineChartData: [] };
        let total = 0;
        let tz = JSON.parse(localStorage.company).user_timezone_name;

        data.lineChartData = resp_data.aggregations.conversation_over_time.buckets.map((d) => {
            total += d.doc_count;
            let date = +moment(d.key).tz(tz).format("x");
            return [date, d.doc_count];
        });

        data.nodata = total === 0;

        return data;
    }
    if (
        [
            "youtube_post_likes",
            "youtube_post_comments",
            "youtube_post_views",
            "youtube_post_shares",
            "youtube_post_engagements",
            "youtube_avg_durations",
            "subs_lost",
            "subs_gained",
        ].includes(chart_name)
    ) {
        let obj = {
            nodata: false,
            aggs_data: [],
        };
        let tz = JSON.parse(localStorage.company).user_timezone_name;
        let total = 0;
        resp_data.data?.aggregations?.data_over_time?.buckets.forEach((likes) => {
            let d = +moment(likes.key).tz(tz).format("x");
            let value = chart_name === "youtube_avg_durations" ? Math.round(likes.total_stats?.value / 60) : likes.total_stats?.value;
            obj.aggs_data.push([d, value || 0]);

            total += value;
        });

        obj.nodata = total === 0;

        return obj;
    }

    if (chart_name === "youtube_post_reach") {
        // console.log(resp_data);

        let obj = {
            nodata: resp_data.hits.total === 0,
            views_agg: [],
            avg_value: 0,
        };

        let tz = JSON.parse(localStorage.company).user_timezone_name;
        let total = 0;

        resp_data.aggregations.conversation_over_time_estimated_reach.buckets.forEach((reach) => {
            let d = +moment(reach.key).tz(tz).format("x");
            obj.views_agg.push([d, reach.stats.sum || 0]);
            total += reach.stats.sum;
        });

        let totallength = resp_data.hits.total || 1;
        obj.avg_value = +(total / totallength).toFixed(2);

        return obj;
    }
    if (chart_name === "engagement_over_time") {
        let modifiedData = {
            nodata: resp_data.hits.total === 0,
            total_agg: [],
            avg_value: 0,
        };

        let tz = JSON.parse(localStorage.company).user_timezone_name;

        let total = 0;
        resp_data.aggregations.reactions_datewise_breakdown.buckets.forEach((obj) => {
            let d = +moment(obj.key).tz(tz).format("x");
            let sum_of_reaction = +obj.like_count?.sum + obj.comment_count?.sum + obj.share_count?.sum + obj.view_count?.sum;
            modifiedData.total_agg.push([d, sum_of_reaction || 0]);
            total += sum_of_reaction;
        });

        let totallength = resp_data.hits.total || 1;
        modifiedData.avg_value = +(total / totallength).toFixed(2);

        return modifiedData;
    }
};
